import { supabaseClient } from '../../../shared/utils/supabaseClient';

export const createInviteToken = async ({ groupId, memberDbId, adminId }) => {
  const expiresAt = new Date();
  expiresAt.setDate(expiresAt.getDate() + 7);

  const { data, error } = await supabaseClient
    .from('member_invites')
    .insert({
      group_id: groupId,
      member_db_id: memberDbId,
      invited_by: adminId,
      expires_at: expiresAt.toISOString(),
    })
    .select()
    .single();

  if (error) throw error;
  return data;
};

export const getInviteByToken = async (token) => {
  // SECURITY DEFINER RPC — replaces the old anon direct reads on
  // member_invites/members/groups/hands (RLS for those was removed).
  // Returns one jsonb object { invite, member, group, positions:[int,...] },
  // or null when no invite matches the token.
  const { data, error } = await supabaseClient
    .rpc('get_invite_by_token', { p_token: token });

  if (error) throw error;
  if (!data) throw new Error('Invite not found');

  // Map the RPC's singular keys into the exact shape the wizard consumes:
  // plural members/groups, and hands as objects with position_number.
  return {
    ...data.invite,
    members: {
      ...data.member,
      hands: (data.positions || []).map((n) => ({ position_number: n })),
    },
    groups: data.group,
  };
};

export const consumeInviteToken = async (token) => {
  const { error } = await supabaseClient
    .from('member_invites')
    .update({
      status: 'accepted',
      accepted_at: new Date().toISOString(),
    })
    .eq('token', token);

  if (error) throw error;
};
